/*
 *  Class Rates
 */
export
default class Rates {
    constructor() {
        this.filters = document.querySelectorAll('.rates__filter select');
    }

    hide(el) {
        el.classList.add('hidden');
    }

    show(el) {
        el.classList.remove('hidden');
    }

    toggleContentBySelect(select) {
        if (select.value.length) {
            this.show(select.closest('.rates').querySelector('.rates__content'));
        } else {
            this.hide(select.closest('.rates').querySelector('.rates__content'));
        }
    }

    updateContent(select) {
        this.toggleContentBySelect(select);

        const content = select.closest('.rates').querySelector('.rates__content');
        if (select.value.length) {
            let config = JSON.parse(select.value);
            config.label = select.options[select.selectedIndex].text;
            for (let i in config) {
                const attr = `data-${i}`;
                const els = content.querySelectorAll(`[${attr}]`);
                for (let ii = 0; ii < els.length; ii++) {
                    const value = els[ii].getAttribute(attr);
                    els[ii].innerHTML = value.replace('%s', config[i]);
                }
            }
        }
    }

    onChange(e) {
        this.updateContent(e.target);
    }

    init() {
        for (let i = 0; i < this.filters.length; i++) {
            const filter = this.filters[i];
            filter.addEventListener('change', this.onChange.bind(this));
            this.updateContent(filter);
        }
    }
}
